<script>
export default {
    name: 'IconUnfold',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-unfold"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill="currentColor"
            d="M56 20L32.004 44 8 20z"
            fill-rule="evenodd"
        />
    </svg>
</template>
